import React, {Component} from "react";
import {Route, Switch} from "react-router-dom";
import foodbg from "../../assets/img/FoodBG.svg";
import logo from "../../assets/img/logo.svg";
import CopyrightFooter from "../Components/CopyrightFooter";
import ForgotPasswd from "./ForgotPasswd";
import Login from "./Login";

class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      baseurl: props.match.path,
    };
  }
  render() {
    return (
      <div className="row no-gutters min-h-fullscreen bg-white">
        <div
          className="col-md-6 col-lg-5 col-xl-4 bg-theme"
          style={{ backgroundImage: `url(${foodbg})` }}
        >
          <div className="text-center pt-30 row h-100">
            <div className="align-self-start">
              <img
                src={logo}
                alt="NG-POS"
                height={"160"}
                width={"90"}
                style={{ maxHeight: "80px", height: "auto" }}
              />
            </div>
            <div className="align-self-end pb-30">
              <h4 className="text-white">Check the Status</h4>
              <p className="text-white fs-11">
                Refresh Table And Cart Before Taking Order.
              </p>
              <CopyrightFooter />
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-7 col-xl-8 align-self-center">
          <Switch>
            <Route path={this.state.baseurl} exact component={Login} />
            <Route
              path={this.state.baseurl + `/Login`}
              exact
              component={Login}
            />
            <Route
              path={this.state.baseurl + `/ForgotPassword`}
              exact
              component={ForgotPasswd}
            />
          </Switch>
        </div>
      </div>
    );
  }
}
export default Auth;
